<template>
  <div
    class="table-carousel-wrap"
    :class="`${element.isLock ? 'wrap' : 'wrap cursor'} ${
      element.compData.type
    }-theme-${element.compData.styleId}`"
    :style="{
      ...getStyles({
        ...element.compData.styles,
        wrapHeight: element.boxStyle.height,
      }),
    }"
  >
  <!-- 表头 -->
    <div
      class="table-header"
      v-if="element.compData.config.tableHeaderShow"
    >
      <div
        v-for="(item, index) in element.compData.data.columns"
        :key="index"
        :style="{
          width: item.width + '%',
        }"
      >
        {{item.displayName}}
      </div>
    </div>
    <!-- 滚动 -->
    <VueSeamlessScroll
      ref="vueseamlessscroll"
      v-if="element.compData.config.tableRowScroll"
      :style="{
        height: tableShowHeight + 'px',
        overflow: element.compData.config.tableRowScroll ? 'hidden' : 'auto',
      }" :data="element.compData.data.data" :class-option="classOption">
      <ul
        :style="{
          overflow: 'auto',
        }"
      >
        <li class="table-row"
         :style="{
          height:  liHieght / maxTableConut + 'px',
         }"
         v-for="(item, index) in element.compData.data.data" :key="index" >
          <div v-for="(it, ins) in element.compData.data.columns"
            @click="hancleClickCell(item[it.colFieldName])"
            :key="ins"
            :style="{
              width: it.width + '%',
              textAlign: it.textAlign,
              justifyContent: it.textAlign,
              fontSize: it.fontSize + 'px',
              color: it.color
            }"
          >
            <span v-if="it.dataType == 'text'">
              {{item[it.colFieldName]}}
            </span>
            <div v-else>
              <img :width="it.imgWidthPercent + '%'" height="100%" :src="item[it.colFieldName]" alt="">
            </div>
          </div>
        </li>
      </ul>
    </VueSeamlessScroll>
    <ul v-else
      class="table-scrollbar"
      :style="{
        height: liHieght + 'px',
        overflow: 'auto',
      }"
    >
      <li 
        class="table-row"
        v-for="(item, index) in element.compData.data.data" :key="index"
        :style="{
          height: (liHieght) / maxTableConut + 'px',
         }"
        >
        <div v-for="(it, ins) in element.compData.data.columns"
          @click="hancleClickCell(item[it.colFieldName])"
          :key="ins"
          :style="{
            height: '100%',
            width: it.width + '%',
            textAlign: it.textAlign,
            justifyContent: it.textAlign,
            fontSize: it.fontSize + 'px',
            color: it.color
          }"
        >
          <span v-if="it.dataType == 'text'">
            {{item[it.colFieldName]}}
          </span>
          <div v-else>
            <img :width="it.imgWidthPercent + '%'" height="100%" :src="item[it.colFieldName]" alt="">
          </div>
        </div>
      </li>
    </ul>
    <div v-if="fontStyleTable" v-html="fontStyleTable"></div>
  </div>
</template>

<script>
import VueSeamlessScroll from 'vue-seamless-scroll'
import { fontFamily } from '@/util/editor/fonts/fontFamily'

export default {
  name: "table-carousel",
  props: {
    element: {
      type: Object,
      require: true,
    },
  },
  data() {
    return {
      // loading: true
      fontStyleTableName: null,
      fontStyleTableUrl: null,
    };
  },
  computed: {
    plugin: function() {
      return this.$getPlugin(this.element.id)
    },
    tableWidth() {
      return (this.element.compData.data.columns || []).reduce((accumulator, current) => accumulator + current.width, 0)
    },
    // 组件字体style html代码 表头
    fontStyleTable() {
      if (
        !this.fontStyleTableName ||
        this.fontStyleTableName == "" ||
        !this.fontStyleTableUrl ||
        this.fontStyleTableUrl == ""
      )
        return;
      return `<style>
        @font-face {
          font-family: ${this.fontStyleTableName}; 
          ${
            this.fontStyleTableUrl !== ""
              ? "src: url(" + this.fontStyleTableUrl + ")"
              : ""
          }
        }
      </style>`;
    },
    classOption() {
       return {
        autoPlay: true,
        step: this.element.compData.config.scollStep, // 数值越大速度滚动越快
        limitMoveNum: 1, // 开始无缝滚动的数据量 this.dataList.length
        hoverStop: true, // 是否开启鼠标悬停stop
        direction: 1, // 0向下 1向上 2向左 3向右
        // openWatch: true, // 开启数据实时监控刷新dom
        singleHeight: 0, // 单步运动停止的高度(默认值0是无缝不停止的滚动) direction => 0/1
        singleWidth: 0, // 单步运动停止的宽度(默认值0是无缝不停止的滚动) direction => 2/3
        waitTime: 100 // 单步运动停止的时间(默认值1000ms)
      }
    },
    maxTableConut() {
      return this.element.compData.config.tableCol
    },
    liHieght() {
      return this.element.boxStyle.height - this.element.compData.styles.headHeigth * this.element.compData.config.tableHeaderShow
    },
    tableShowHeight() {
      const maxTableConut = this.maxTableConut;
      const dataLength = (this.element.compData.data.data || []).length
      const liHieght = this.liHieght
      if (maxTableConut > dataLength) {
        return liHieght / maxTableConut * dataLength
      } else {
        return liHieght
      }
    }
  },
  methods: {
    hancleClickCell(text) {
      this.$blueMap.trigger({
        nodeType: 'plugin',
        pluginId: this.element.id,
        dataKey: 'onclick',
        eventData: {
          value: text,
          data: this.plugin,
          event: null
        }
      })
    },
    getStyles(styles) {
      if (!styles) return;
      const res = {};
      Object.keys(styles).forEach((item) => {
        res[`--${item}`] =
          typeof styles[item] === "number" ? styles[item] + "px" : styles[item];
      });
      return Object.assign(res, {
        opacity: this.element["opacity"] / 100,
      });
    },
    /**
     * 动态添加自定义字体 表头
     */
    handleUpdateFontStyleTable() {
      if (!this.element.compData.styles.tableFontFamily) return;
      const font = fontFamily.filter(
        (it) => it.name === this.element.compData.styles.tableFontFamily
      )[0];
      if (font.name == "") return;
      this.fontStyleTableName = font.name;
      this.fontStyleTableUrl = font.url;
    },
    handleScrollReset() {
      if (this.$refs.vueseamlessscroll) {
        this.$refs.vueseamlessscroll._initMove()
      }
    }
  },
  mounted() {
    // this.$nextTick(() => {
    //   this.loading = false
    // })
    this.$blueMap.trigger({
      nodeType: 'plugin',
      pluginId: this.element.id,
      dataKey: 'onmounted',
      eventData: {
        value: null,
        data: this.plugin,
        event: null
      }
    })
    this.handleUpdateFontStyleTable();
  },
  watch: {
    // 侦听字体变化 表格主体
    "element.compData.styles.tableFontFamily": function () {
      this.handleUpdateFontStyleTable();
    },
    "element.compData.config.tableRowScroll": function (val) {
      // if (val) {
      //   this.$refs.vueseamlessscroll._startMove()
      // } else {
      //   this.$refs.vueseamlessscroll.yPos = 0

      //   this.$refs.vueseamlessscroll._cancle()
      // }
      // this.handleRowScroll()
    },
    'element.compData.data.columns': {
      handler: function() {
        this.handleScrollReset()
      },
      deep: true
    },
    'tableShowHeight': function() {
      this.handleScrollReset()
    }
  },
  components: {
    VueSeamlessScroll    
  },
};
</script>

<style lang='less' scoped>

.table-carousel-wrap {
  height: var(--wrapHeight);
  font-family: var(--tableFontFamily) !important;
  overflow: hidden;
  .table-header, .table-row {
    display: flex;
    align-items: center;
    height: 40px;
    background: var(--backgroundThColor);;
    color: #fff;
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
  }
  .table-row {
    > div {
      display: flex;
      align-items: center;
      text-overflow: ellipsis;
      white-space: nowrap;
      overflow: hidden;
    }
  }
  .table-row:nth-child(2n + 1) {
    border: 1px solid var(--backgroundRowColor1);
    background: var(--backgroundRowColor1);
  }
  .table-row:nth-child(2n) {
    border: 1px solid var(--backgroundRowColor2);
    background: var(--backgroundRowColor2);
  }
  .table-header {
    height: var(--headHeigth);
    font-size: var(--headFontSize);
    color: var(--headFontColor);
    background: var(--headBgColor);
    font-weight: bold;
    > div {
      display: inline-block;
      text-align: var(--headtextAlign);
      vertical-align: middle;
    }
  }
}
.table-scrollbar {
  /*定义滚动条样式（高宽及背景）*/
    &::-webkit-scrollbar {
        width: 10px;
        height: 1px;
        background:  rgba(255, 255, 255, 0.3);
    }
    /*定义滚动条轨道（凹槽）样式*/
    &::-webkit-scrollbar-track {
      display: none;
      border-radius: 10px;

    }
    /*定义滑块 样式*/
    &::-webkit-scrollbar-thumb {
        border-radius: 5px;
        background-color: var( --tableBarColor);
    }
}

</style>
